import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2109f046"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-body-light" }
const _hoisted_3 = {
  key: 2,
  class: "h2 text-center text-darkening-grey"
}
const _hoisted_4 = {
  key: 3,
  class: "row no-space"
}

import { onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSyncOpsStore } from '@/store/syncOpportunities'
import { useUserStore } from '@/store/user'
import { getErrorTitle, getErrorMessage } from '@/helpers/errors'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import UpgradeDialog from '@/components/UpgradeDialog.vue'
import NavBar from '@/components/NavBar.vue'
import SyncOpDetails from './SyncOpDetails.vue'
import SyncOpItem from './SyncOpItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AllSyncOps',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const syncOpsStore = useSyncOpsStore()
const userStore = useUserStore()

const currentPage = ref(1)
const errorMessage = ref('')
const errorTitle = ref('')
const isLoading = ref(true)
const selectedSyncOp = ref<SyncOp | undefined>()
const syncOpManuallySelected = ref(false)
const upgradeDialog = ref<InstanceType<typeof UpgradeDialog> | null>(null)

const hasProOrLabelSubscription = userStore.hasProOrLabelSubscription

function isDesktop(): boolean {
  // matches --max-medium
  return window.matchMedia('(min-width: 960px)').matches
}

async function getSyncOps() {
  if (!hasProOrLabelSubscription) {
    upgradeDialog?.value?.show()
  }

  try {
    isLoading.value = true

    await syncOpsStore.getSyncOps(currentPage.value)

    const urlId = route.params.syncOpId as string | undefined

    if (urlId?.length) {
      selectedSyncOp.value = syncOpsStore.availableSyncOps.find(op => op.id.toString() === urlId)
        || syncOpsStore.availableSyncOps[0]
      syncOpManuallySelected.value = true
    } else if (syncOpsStore.availableSyncOps.length) {
      selectedSyncOp.value = syncOpsStore.availableSyncOps[0]
    }

    isLoading.value = false
  } catch (error) {
    errorTitle.value = getErrorTitle(error)
    errorMessage.value = getErrorMessage(error)
  }
}

function handleSelection(syncOp: SyncOp) {
  const target = {
    name: 'SyncOpportunities',
    params: { syncOpId: syncOp.id.toString() },
  }

  if (isDesktop()) {
    router.replace(target)
  } else {
    route.params.syncOpId ? router.replace(target) : router.push(target)
  }
}

function closeModal() {
  router.push({ name: 'SyncOpportunities' })
}

watch(
  () => route.params.syncOpId,
  newId => {
    if (typeof newId === 'string' && newId.length) {
      const found = syncOpsStore.availableSyncOps.find(op => op.id.toString() === newId)
      if (found) {
        selectedSyncOp.value = found
        syncOpManuallySelected.value = true
      }
    } else {
      syncOpManuallySelected.value = false
    }
  },
)

onMounted(async () => {
  document.body.classList.remove('bg-white')
  document.body.classList.add('bg-lighter-grey')
  await getSyncOps()
})
onUnmounted(() => {
  document.body.classList.remove('bg-lighter-grey')
  document.body.classList.add('bg-white')
})

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NavBar, { "is-mobile": "" }),
    _createVNode(UpgradeDialog, {
      ref_key: "upgradeDialog",
      ref: upgradeDialog
    }, null, 512),
    _createElementVNode("section", {
      class: _normalizeClass(["sync-opportunities", { blurred: !_unref(hasProOrLabelSubscription) }]),
      "data-testid": "sync-opportunities"
    }, [
      (!syncOpManuallySelected.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _withDirectives((_openBlock(), _createElementBlock("h1", null, [
              _createTextVNode(" Sync Opportunities ")
            ])), [
              [_directive_translate]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_2, [
              _createTextVNode(" Apply for your tracks to be featured on TV, movies, ads, games and more. ")
            ])), [
              [_directive_translate]
            ])
          ]))
        : _createCommentVNode("", true),
      (isLoading.value)
        ? (_openBlock(), _createBlock(LoaderErrorBlock, {
            key: 1,
            "error-message": errorMessage.value,
            class: "row no-space justify-center"
          }, null, 8, ["error-message"]))
        : (!_unref(syncOpsStore).availableSyncOps.length)
          ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createTextVNode(" No sync opportunity available at this time. ")
            ])), [
              [_directive_translate]
            ])
          : (_openBlock(), _createElementBlock("section", _hoisted_4, [
              _createElementVNode("aside", {
                class: _normalizeClass(["col-4-medium sync-op-items", { 'is-hidden-below-small': syncOpManuallySelected.value }]),
                "data-testid": "syncOpList"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syncOpsStore).availableSyncOps, (syncOp) => {
                  return (_openBlock(), _createBlock(SyncOpItem, {
                    key: syncOp.id,
                    "data-testid": `syncOpItem-${syncOp.id}`,
                    "is-selected": syncOp.id === selectedSyncOp.value?.id,
                    "sync-op": syncOp,
                    onClick: ($event: any) => (handleSelection(syncOp))
                  }, null, 8, ["data-testid", "is-selected", "sync-op", "onClick"]))
                }), 128))
              ], 2),
              _createElementVNode("section", {
                class: _normalizeClass(["col-8", { 'is-hidden-below-small': !syncOpManuallySelected.value, 'details-modal-open': syncOpManuallySelected.value }])
              }, [
                (selectedSyncOp.value)
                  ? (_openBlock(), _createBlock(SyncOpDetails, {
                      key: 0,
                      "sync-op": selectedSyncOp.value,
                      onCloseModal: closeModal
                    }, null, 8, ["sync-op"]))
                  : _createCommentVNode("", true)
              ], 2)
            ]))
    ], 2)
  ]))
}
}

})